import {
    GetCustomerSupportRequestsResponse,
    GetL1AssessmentsResponse,
    GetMigrationPlanTotalsResponse,
    GetOrgServersResponse,
    GetInstancesResponse,
    GetFastshiftCustomerDomainsResponse,
    GetFastshiftCustomerDomainResponseData,
    GetCustomerDomainEngagementResponseData,
    CustomerDomainEngagementExpectedError,
    FastshiftUserDetailsExpectedError,
    GetFastshiftUserResponse,
    GetFastshiftSupportRequestsResponseData,
    FastshiftTableControlsPayload
} from "@/libraries/bxp-web-stargate-client/src";

type BaseThunk = {
    pending: boolean;
    error: string | null;
};

export type Org = {
    id: string;
    isAdmin: boolean;
    name: string;
};

export type CloudSitesByOrg = {
    orgId: string;
    orgName: string;
    cloudSites: {
        baseUrl: string;
        displayName: string;
        cloudId: string;
    }[];
};

export type Orgs = BaseThunk & {
    data: Org[];
};

export type OrgServers = BaseThunk & {
    data: GetOrgServersResponse["data"];
};

export type AvailableCloudSitesByOrg = BaseThunk & {
    data: CloudSitesByOrg[];
};

export type MigrationPlanTotals = BaseThunk & {
    data: GetMigrationPlanTotalsResponse;
};

export type L1Assessments = BaseThunk & {
    data: GetL1AssessmentsResponse;
};

export type CustomerSupportRequests = BaseThunk & {
    data: GetCustomerSupportRequestsResponse["data"]["customerSupport"]["me"]["requests"]["page"];
};

export type InstancesRequest = BaseThunk & {
    data: { instances: GetInstancesResponse["instances"]; totalCount: number };
};

export type FastshiftCustomerDomainsState = BaseThunk & {
    data: GetFastshiftCustomerDomainsResponse;
};

export type CustomerDomainDetails = BaseThunk & {
    data: GetFastshiftCustomerDomainResponseData | null;
};

export type CustomerDomainOrg = NonNullable<
    CustomerDomainDetails["data"]
>["orgsWithAdminRole"][number];

export type CustomerDomainEngagement = BaseThunk & {
    data: GetCustomerDomainEngagementResponseData | null;
};

export {
    CustomerDomainEngagementExpectedError,
    FastshiftUserDetailsExpectedError
};

export const FastshiftApiAbortError = "AbortError";

export type UserDetails = BaseThunk & {
    data: GetFastshiftUserResponse["data"] | null;
};

export type SupportRequests = BaseThunk & {
    data: GetFastshiftSupportRequestsResponseData;
};

export type PageStateCache = {
    selectionTableControls: FastshiftTableControlsPayload;
    migrationStatusTableControls: FastshiftTableControlsPayload;
};
